import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
let InstitutionApi = class InstitutionApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        this.getIdps = () => {
            const url = this.urls.getIdps;
            return this.http.get({
                url,
            });
        };
    }
};
InstitutionApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.PassportPublicUrls)),
    __metadata("design:paramtypes", [Object, Object])
], InstitutionApi);
export { InstitutionApi };
